<template>
	<section class="module-margin container">
		<div class="container-inner">
			<div class="tile" v-for="(tile, k) in data.tiles" :key="k">
				<WpLink :url="tile.link.url || ''" class="inner" :class="'type-' + tile.type">
					<span class="icon" v-html="tileIcon(tile.type)"></span>
					<div class="info">
						<h3 class="title font-size--26">{{ tile.title }}</h3>
						<span class="msg font-size--16">{{ tile.text }}</span>
					</div>
				</WpLink>
			</div>
		</div>
	</section>
</template>

<script>
import { system, fish, leaft, gear, heartch } from '@/icons'
import WpLink from '@/components/elements/WpLink'

export default {
	name: 'info-tiles',
	props: ['data'],
	methods: {},
	components: {
		WpLink,
	},
	methods: {
		tileIcon(type) {
			switch (type) {
				case 'blue':
					return fish()
					break
				case 'red':
					return heartch()
					break
				case 'green':
					return leaft()
					break
				case 'purple':
					return gear()
					break
				default:
					return system()
					break
			}
		},
	},
}
</script>

<style lang="scss">
@import '@/assets/vars.scss';
@import '@/assets/mixins.scss';

.module-info_tiles {
	.container-inner {
		display: flex;
		justify-content: center;
		margin: -25px;
		flex-wrap: wrap;
		@include mquery($phone) {
			margin: -12px;
		}
		.tile {
			width: 100%;
			flex-basis: 0;
			flex-grow: 1;
			padding: 25px;
			@include mquery($tablet) {
				min-width: 50%;
				max-width: 50%;
			}
			@include mquery($phone) {
				padding: 12px;
				min-width: 100%;
				max-width: 100%;
			}
			.inner {
				border-radius: $radius;
				padding: 50px 25px;
				text-decoration: none;
				display: flex;
				flex-direction: column;
				text-align: center;
				height: 100%;
				transition: box-shadow 0.15s ease-in-out;
				@include mquery($tablet) {
					padding: 30px 20px;
				}
			}
			.msg {
				line-height: 1.2;
			}
			.title {
				margin-top: 10px;
				margin-bottom: 10px;
			}
			.type {
				&-default {
					background-color: var(--gray);
					&:hover {
						box-shadow: 0 0 0 2px var(--dark);
					}
				}
				&-green {
					background-color: var(--greenLight);
					color: var(--green);
					&:hover {
						box-shadow: 0 0 0 2px var(--green);
					}
				}
				&-red {
					background-color: var(--redLight);
					&:hover {
						box-shadow: 0 0 0 2px var(--red);
					}
					color: var(--red);
				}
				&-blue {
					color: var(--blue);
					background-color: var(--blueLight);
					&:hover {
						box-shadow: 0 0 0 2px var(--blue);
					}
				}
				&-purple {
					color: var(--purple);
					background-color: var(--purpleLight);
					&:hover {
						box-shadow: 0 0 0 2px var(--purple);
					}
				}
			}
		}
		.icon {
			svg {
				height: 73px;
				width: auto;
			}
		}
	}
}
</style>
